import React from 'react';

import { CHARTS_BY_FIELD_TYPE } from '@components/ScreenerResults/ScreenerChart/constants';
import { ChartableType } from '@components/ScreenerResults/ScreenerChart/types';
import { calcData } from '@components/ScreenerResults/ScreenerChart/utils';
import { humanize } from '@components/utils';

import { Subtitle } from '../shared';

interface ScreenerChartProps {
  type: ChartableType;
  answers: any[];
  total?: number;
}

export const ScreenerChart: React.FC<React.PropsWithChildren<ScreenerChartProps>> = ({ type, answers, total }) => {
  const Chart = CHARTS_BY_FIELD_TYPE[type];

  const data = calcData(type, answers);

  const shouldShowBlank = total && (type === 'number_range' ? total > answers.length : total >= answers.length);

  if (shouldShowBlank) {
    data.push({ x: 'Blank', y: total - answers.length });
  }

  const dataToDisplay = type == 'number' ? data.reverse() : data;

  const answeredTotal = answers.filter((a) => a).length;

  if (total === 0 || !Chart) {
    return null;
  }

  return (
    <>
      <Subtitle type={humanize(type)} total={total} />
      <Chart data={dataToDisplay} total={answeredTotal} />
    </>
  );
};
